module.exports = __webpack_public_path__ + "static/media/icon-sync.16827cf1.svg";